import { render } from "./HomeCom.vue?vue&type=template&id=59cd2615&scoped=true"
import script from "./HomeCom.vue?vue&type=script&lang=js"
export * from "./HomeCom.vue?vue&type=script&lang=js"

import "./HomeCom.vue?vue&type=style&index=0&id=59cd2615&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cd2615"]])

export default __exports__